import { NgModule } from '@angular/core';
import { provideRouter, RouterModule, Routes, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { CanActivateManageWidgetsGuardService, ManageWidgetsComponent } from '@ddv/manage-widgets';
import { ViewEditDashboardComponent, CanDeactivateViewEditGuard } from '@ddv/views';

import { clientsResolver } from './clients.resolver';
import { fundsResolver } from './funds.resolver';
import { fuzzyDatesResolver } from './fuzzy-dates.resolver';
import { userEntitlementsResolver } from './user-entitlements.resolver';
import { userPreferencesResolver } from './user-preferences.resolver';
import { userResolver } from './user.resolver';
import { viewTilesResolver } from './view-tiles.resolver';
import { MainComponent } from '../main/main.component';

// ParsedRouteService makes assumptions about the route configuration here
// if you add/modify these routes, we check the comments in ParsedRouteService
const appRoutes: Routes = [
    {
        path: ':clientCode',
        component: MainComponent,
        resolve: {
            user: userResolver,
            entitlements: userEntitlementsResolver,
            clients: clientsResolver,
            fuzzyDates: fuzzyDatesResolver,
            preferences: userPreferencesResolver,
            viewTiles: viewTilesResolver,
        },
        children: [
            { path: '', redirectTo: 'views/view/none', pathMatch: 'full' },
            { path: 'home', redirectTo: 'views/view/none', pathMatch: 'full' },
            {
                path: 'widgets/edit/:coreWidgetId',
                component: ManageWidgetsComponent,
                canActivate: [
                    CanActivateManageWidgetsGuardService,
                ],
                resolve: {
                    funds: fundsResolver,
                },
            },
            {
                path: 'views/:mode/:dashboardId',
                component: ViewEditDashboardComponent,
                canDeactivate: [
                    CanDeactivateViewEditGuard,
                ],
                resolve: {
                    funds: fundsResolver,
                },
            },
            {
                path: 'boards',
                loadComponent: async () => import('@ddv/feature-dashboards').then((m) => m.MainDashboardsComponent),
                resolve: {
                    funds: fundsResolver,
                },
                loadChildren: async () => import('@ddv/feature-dashboards').then((m) => m.routes),
            },
        ],
    },
];

@NgModule({
    providers: [
        provideRouter(
            appRoutes,
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always', urlUpdateStrategy: 'eager' }),
        ),
    ],
    exports: [
        RouterModule,
    ],
})
export class AppRoutingModule { }
